import { render } from "./TaskMoveTo.vue?vue&type=template&id=71a0dec3&ts=true"
import script from "./TaskMoveTo.vue?vue&type=script&lang=ts"
export * from "./TaskMoveTo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__